// src/services/encryptNotes.js
export async function encryptWithUserKey(plainText, userKeyHex) {
  if (!plainText || !userKeyHex) return plainText;

  const enc = new TextEncoder();
  const data = enc.encode(plainText);

  const keyBytes = hexToBytes(userKeyHex);
  const cryptoKey = await window.crypto.subtle.importKey(
    "raw",
    keyBytes,
    { name: "AES-GCM" },
    false,
    ["encrypt"]
  );

  const iv = window.crypto.getRandomValues(new Uint8Array(12));

  // SubtleCrypto renvoie le ciphertext **avec le tag collé à la fin**
  const encrypted = new Uint8Array(await window.crypto.subtle.encrypt(
    { name: "AES-GCM", iv },
    cryptoKey,
    data
  ));

  // Séparer le tag (16 bytes à la fin) du ciphertext
  const tag = encrypted.slice(encrypted.length - 16);
  const cipher = encrypted.slice(0, encrypted.length - 16);

  // Retourner IV + TAG + ciphertext comme le backend
  return bytesToBase64(new Uint8Array([...iv, ...tag, ...cipher]));
}

export async function decryptWithUserKey(encryptedBase64, userKeyHex) {
  if (!encryptedBase64 || !userKeyHex) return encryptedBase64;

  try {
    const encryptedBytes = base64ToBytes(encryptedBase64);

    // Structure backend : [IV (12) | TAG (16) | CIPHERTEXT (reste)]
    const iv = encryptedBytes.slice(0, 12);
    const tag = encryptedBytes.slice(12, 28);
    const data = encryptedBytes.slice(28);

    const keyBytes = hexToBytes(userKeyHex);
    const cryptoKey = await window.crypto.subtle.importKey(
      "raw",
      keyBytes,
      { name: "AES-GCM" },
      false,
      ["decrypt"]
    );

    // ✅ AES-GCM attend le tag collé à la fin du ciphertext
    const cipherWithTag = new Uint8Array([...data, ...tag]);

    const decrypted = await window.crypto.subtle.decrypt(
      { name: "AES-GCM", iv },
      cryptoKey,
      cipherWithTag
    );

    return new TextDecoder().decode(decrypted);
  } catch (err) {
    // Si ce n'est pas chiffré (texte brut) ou si le déchiffrement échoue
    return encryptedBase64;
  }
}

// export async function decryptWithUserKey(encryptedBase64, userKeyHex) {
//   if (!encryptedBase64 || !userKeyHex) return encryptedBase64;

//   const encryptedBytes = base64ToBytes(encryptedBase64);

//   const iv = encryptedBytes.slice(0, 12);
//   const data = encryptedBytes.slice(12);

//   const keyBytes = hexToBytes(userKeyHex);
//   const cryptoKey = await window.crypto.subtle.importKey(
//     "raw",
//     keyBytes,
//     { name: "AES-GCM" },
//     false,
//     ["decrypt"]
//   );

//   console.log("Decrypt debug:", {
//     text: encryptedBase64.slice(0, 40) + "...",
//     key: userKeyHex,
//     ivLength: iv.length,
//     dataLength: data.length
//   });

//   const decrypted = await window.crypto.subtle.decrypt(
//     { name: "AES-GCM", iv },
//     cryptoKey,
//     data
//   );

//   return new TextDecoder().decode(decrypted);
// }

// ------------------ Utils ------------------
function hexToBytes(hex) {
  const bytes = new Uint8Array(hex.length / 2);
  for (let i = 0; i < bytes.length; i++) {
    bytes[i] = parseInt(hex.substr(i * 2, 2), 16);
  }
  return bytes;
}

function bytesToBase64(bytes) {
  let binary = '';
  const len = bytes.byteLength;
  for (let i = 0; i < len; i++) {
    binary += String.fromCharCode(bytes[i]);
  }
  return window.btoa(binary);
}

function base64ToBytes(base64) {
  const binary = window.atob(base64);
  const bytes = new Uint8Array(binary.length);
  for (let i = 0; i < binary.length; i++) {
    bytes[i] = binary.charCodeAt(i);
  }
  return bytes;
}
